import {styled} from "@mui/material/styles"
import {Box, Button as MUIButton} from "@mui/material"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

interface BigScreenContainerProps {
    open: boolean
    searchbartype: string
}

export const BigScreenContainer = styled("div")<BigScreenContainerProps>`
    position: relative;
    > div {
        border-bottom-left-radius: ${({theme}) => theme.uxfabric.shape.global.textField.medium.borderRadius};
        border-bottom-right-radius: ${({theme}) => theme.uxfabric.shape.global.textField.medium.borderRadius};
    }
`
export const IconContainer = styled("div")`
    height: 2.75rem;
    width: 2.75rem;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
`

export const SearchArea = styled("div")`
    display: flex;
`

export const CloseButton = styled(MUIButton)`
    && {
        width: 4.5rem;
        height: 100%;
        background: ${({theme}) => theme.uxfabric.background.paper};
        color: ${({theme}) => theme.uxfabric.text.primary};
        font-family: ${({theme}) => `${theme.uxfabric.global.body2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
        border-radius: 0;
        border: 0;

        &:hover,
        &:active {
            background: ${({theme}) => theme.uxfabric.background.paper};
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`

export const BigScreenModalWrapper = styled(Box)`
    position: relative;
`
